import Papa from 'papaparse';


const gridId = '457828492';
export default async function fetchDataFromSpreadsheet() {
  const url =
    "https://docs.google.com/spreadsheets/d/e/2PACX-1vRiw274r-fvxtn3-FnjNv7vrc271B-FceTOWWGLsvoYQIDLTfQk7wq4hKL1RtLhIXoSUBWmfqdHwa9Q/pub?gid=457828492&single=true&output=csv";
  return await fetchCsvAsJson(url);
}

async function fetchCsvAsJson(url) {
  const response = await fetch(url);
  if (!response.ok) throw new Error('Network response was not ok');
  const csvText = await response.text();

  // Wrap Papa.parse in a Promise so we can await it
  return await new Promise((resolve, reject) => {
    Papa.parse(csvText, {
      header: true,
      skipEmptyLines: true,
      complete: (results) => resolve(results.data),
      error: reject,
    });
  });
}
